import React from 'react';
import BaseDashboardLayout from './BaseDashboardLayout';
import docItems from '../components/sidebar/items/docItems';

const Doc = ({ children, width }) => {
	return <BaseDashboardLayout children={children} width={width} navItems={docItems} />;
};

export default Doc;
